module.exports = __webpack_public_path__ + "img/noOrder.5d1903b1.png";